let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9Rga7")).then(() => parcelRequire('kGVhZ'));